import { render } from "./vertical.vue?vue&type=template&id=319257c8"
import script from "./vertical.vue?vue&type=script&lang=js"
export * from "./vertical.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__